// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const SkinResurfacingPage = ({ onButtonClick, onBack }) => {
//   const { t } = useTranslation();
  
//   const resurfacingServices = [
//     { name: t('skinResurfacingPage.services.face'), price: t('skinResurfacingPage.prices.face') },
//     { name: t('skinResurfacingPage.services.faceNeck'), price: t('skinResurfacingPage.prices.faceNeck') },
//     { name: t('skinResurfacingPage.services.faceNeckDecollete'), price: t('skinResurfacingPage.prices.faceNeckDecollete') },
//     { name: t('skinResurfacingPage.services.faceNeckDecolleteHands'), price: t('skinResurfacingPage.prices.faceNeckDecolleteHands') },
//     { name: t('skinResurfacingPage.services.decollete'), price: t('skinResurfacingPage.prices.decollete') },
//     { name: t('skinResurfacingPage.services.hands'), price: t('skinResurfacingPage.prices.hands') },
//     { name: t('skinResurfacingPage.services.periorbital'), price: t('skinResurfacingPage.prices.periorbital') },
//     { name: t('skinResurfacingPage.services.backHalf'), price: t('skinResurfacingPage.prices.backHalf') },
//     { name: t('skinResurfacingPage.services.forehead'), price: t('skinResurfacingPage.prices.forehead') },
//     { name: t('skinResurfacingPage.services.nose'), price: t('skinResurfacingPage.prices.nose') },
//     { name: t('skinResurfacingPage.services.chin'), price: t('skinResurfacingPage.prices.chin') },
//     { name: t('skinResurfacingPage.services.neck'), price: t('skinResurfacingPage.prices.neck') },
//     { name: t('skinResurfacingPage.services.cheeks'), price: t('skinResurfacingPage.prices.cheeks') },
//     { name: t('skinResurfacingPage.services.intimate'), price: t('skinResurfacingPage.prices.intimate') },
//     { name: t('skinResurfacingPage.services.elbows'), price: t('skinResurfacingPage.prices.elbows') },
//     { name: t('skinResurfacingPage.services.armsAbove'), price: t('skinResurfacingPage.prices.armsAbove') },
//     { name: t('skinResurfacingPage.services.area1'), price: t('skinResurfacingPage.prices.area1') },
//     { name: t('skinResurfacingPage.services.area2'), price: t('skinResurfacingPage.prices.area2') },
//     { name: t('skinResurfacingPage.services.lips'), price: t('skinResurfacingPage.prices.lips') },
//     { name: t('skinResurfacingPage.services.back'), price: '' }
//   ];

//   const handleServiceClick = (serviceName, servicePrice) => {
//     if (serviceName === t('skinResurfacingPage.services.back')) {
//       onBack();
//     } else {
//       onButtonClick(serviceName, servicePrice);
//     }
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="clinic-logo">
//           <div className="logo-icon">✨</div>
//           <h1>{t('skinResurfacingPage.title')}</h1>
//         </div>
        
//         <div className="user-greeting">
//           <p>{t('skinResurfacingPage.subtitle')}</p>
//         </div>
//       </header>

//       <main className="main-content">
//         <div className="welcome-section">
//           <h2>{t('skinResurfacingPage.welcome')}</h2>
//           <p className="subtitle">{t('skinResurfacingPage.laserResurfacing')}</p>
//           <p className="description">{t('skinResurfacingPage.description')}</p>
//         </div>

//         <div className="buttons-grid">
//           {resurfacingServices.map((service, index) => (
//             <button 
//               key={index}
//               className={`service-btn ${service.name === t('skinResurfacingPage.services.back') ? 'back-btn' : ''}`}
//               onClick={() => handleServiceClick(service.name, service.price)}
//             >
//               <div className="service-info-full">
//                 <span className="service-name-full">{service.name}</span>
//                 {service.price && <span className="service-price">{service.price}</span>}
//               </div>
//             </button>
//           ))}
//         </div>
//       </main>

//       <footer className="footer">
//         <p>{t('skinResurfacingPage.footer.main')}</p>
//         <p className="footer-info">{t('skinResurfacingPage.footer.info')}</p>
//       </footer>
//     </>
//   );
// };

// export default SkinResurfacingPage;





import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SkinResurfacingPage = ({ onButtonClick, onBack }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  
  const resurfacingServices = [
    { id: 1, name: t('skinResurfacingPage.services.face'), price: t('skinResurfacingPage.prices.face') },
    { id: 2, name: t('skinResurfacingPage.services.faceNeck'), price: t('skinResurfacingPage.prices.faceNeck') },
    { id: 3, name: t('skinResurfacingPage.services.faceNeckDecollete'), price: t('skinResurfacingPage.prices.faceNeckDecollete') },
    { id: 4, name: t('skinResurfacingPage.services.faceNeckDecolleteHands'), price: t('skinResurfacingPage.prices.faceNeckDecolleteHands') },
    { id: 5, name: t('skinResurfacingPage.services.decollete'), price: t('skinResurfacingPage.prices.decollete') },
    { id: 6, name: t('skinResurfacingPage.services.hands'), price: t('skinResurfacingPage.prices.hands') },
    { id: 7, name: t('skinResurfacingPage.services.periorbital'), price: t('skinResurfacingPage.prices.periorbital') },
    { id: 8, name: t('skinResurfacingPage.services.backHalf'), price: t('skinResurfacingPage.prices.backHalf') },
    { id: 9, name: t('skinResurfacingPage.services.forehead'), price: t('skinResurfacingPage.prices.forehead') },
    { id: 10, name: t('skinResurfacingPage.services.nose'), price: t('skinResurfacingPage.prices.nose') },
    { id: 11, name: t('skinResurfacingPage.services.chin'), price: t('skinResurfacingPage.prices.chin') },
    { id: 12, name: t('skinResurfacingPage.services.neck'), price: t('skinResurfacingPage.prices.neck') },
    { id: 13, name: t('skinResurfacingPage.services.cheeks'), price: t('skinResurfacingPage.prices.cheeks') },
    { id: 14, name: t('skinResurfacingPage.services.intimate'), price: t('skinResurfacingPage.prices.intimate') },
    { id: 15, name: t('skinResurfacingPage.services.elbows'), price: t('skinResurfacingPage.prices.elbows') },
    { id: 16, name: t('skinResurfacingPage.services.armsAbove'), price: t('skinResurfacingPage.prices.armsAbove') },
    { id: 17, name: t('skinResurfacingPage.services.area1'), price: t('skinResurfacingPage.prices.area1') },
    { id: 18, name: t('skinResurfacingPage.services.area2'), price: t('skinResurfacingPage.prices.area2') },
    { id: 19, name: t('skinResurfacingPage.services.lips'), price: t('skinResurfacingPage.prices.lips') }
  ];

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleBookAppointment = () => {
    const selectedServiceNames = resurfacingServices
      .filter(service => selectedServices.includes(service.id))
      .map(service => `${service.name} - ${service.price}`);
    
    if (selectedServiceNames.length > 0) {
      onButtonClick(`Запись на шлифовку кожи: ${selectedServiceNames.join('; ')}`);
    } else {
      onButtonClick('Запись на консультацию по шлифовке кожи');
    }
  };

  const totalPrice = resurfacingServices
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price.replace(' руб.', '').replace(/\s/g, '');
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">✨</div>
          <h1>{t('skinResurfacingPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('skinResurfacingPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('skinResurfacingPage.welcome')}</h2>
          <p className="subtitle">{t('skinResurfacingPage.laserResurfacing')}</p>
          <p className="description">{t('skinResurfacingPage.description')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {resurfacingServices.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => toggleService(service.id)}
              >
                <div className="service-checkbox">
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-info-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span className="service-name-full" style={{ color: 'white' }}>{service.name}</span>
                  {service.price && (
                    <span className="service-price" style={{ color: 'white' }}>{service.price}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="services-total" style={{ margin: '20px 0', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="total-label" style={{ color: 'white' }}>Выбрано зон:</span>
            <span className="total-count" style={{ background: 'rgba(52,152,219,0.3)', padding: '5px 12px', borderRadius: '20px', color: 'white' }}>{selectedServices.length}</span>
            <span className="total-price" style={{ color: '#2ecc71', fontSize: '18px', fontWeight: '700' }}>{totalPrice} руб.</span>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn book-btn" 
            onClick={handleBookAppointment}
            style={selectedServices.length > 0 ? { background: 'linear-gradient(135deg, rgba(39, 174, 96, 0.9), rgba(46, 204, 113, 0.9))' } : {}}
          >
            <span className="btn-icon">📅</span>
            <span className="btn-text" style={{ color: 'white' }}>
              {selectedServices.length > 0 ? 'Записаться на выбранные зоны' : 'Записаться на консультацию'}
            </span>
          </button>

          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text" style={{ color: 'white' }}>{t('skinResurfacingPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('skinResurfacingPage.footer.main')}</p>
        <p className="footer-info">{t('skinResurfacingPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default SkinResurfacingPage;